import { createFileRoute } from '@tanstack/react-router'

import { LoadingSpinner } from '@/components/LoadingSpinner'
import { PageContent } from '@/components/page-content'
import { PageMenu } from '@/components/page-menu'
import { Skeleton } from '@/components/ui/skeleton'
import { eligibleRoleByIdQueryOptions } from '@/features/eligible-roles/queries'
import { ApplicantsEligibleRolesPage } from '@/modules/user/presentation/pages/applicants/ApplicantsEligibleRolesPage'
import { paginationQueryParamsSchema } from '@/shared/schemas/pagination'

export const Route = createFileRoute('/_authenticated/applicants/eligible-roles/$eligibleRoleId')({
  component: ApplicantsEligibleRolesPage,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `Applicants : ER - ${loaderData}`,
      },
    ],
  }),
  loader: async ({ context: { queryClient }, deps, params: { eligibleRoleId } }) => {
    const response = await queryClient.ensureQueryData(eligibleRoleByIdQueryOptions(eligibleRoleId, deps))
    return response.name
  },
  loaderDeps: ({ search: { itemsPerPage, page } }) => ({ itemsPerPage, page }),
  pendingComponent: () => (
    <>
      <PageMenu>
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-6 w-56" />
      </PageMenu>
      <PageContent>
        <LoadingSpinner />
      </PageContent>
    </>
  ),
  validateSearch: paginationQueryParamsSchema,
})
